import React, { ReactNode } from 'react';
import Icon from './Icon';
import { classnames } from '@/libs/utils';

export type AlertBannerType = 'info' | 'warning' | 'error' | 'lock';

interface AlertBannerProps {
  type: AlertBannerType;
  children: ReactNode;
  className?: string;
}

export default function AlertBanner({ type, children, className }: AlertBannerProps) {
  const getIcon = () => {
    switch (type) {
      case 'info':
        return <Icon name="IconInfoCircle" size={16} className="shrink-0" />;
      case 'warning':
        return <Icon name="IconAlertTriangle" size={16} className="shrink-0" />;
      case 'error':
        return <Icon name="IconExclamationCircle" size={16} className="shrink-0" />;
      case 'lock':
        return <Icon name="IconLock" size={16} className="shrink-0" />;
      default:
        return <Icon name="IconAlertTriangle" size={16} className="shrink-0" />;
    }
  };

  const getColorClass = () => {
    switch (type) {
      case 'info':
        return 'border border-blue-200 bg-blue-50 text-blue-700';
      case 'warning':
        return 'border border-amber-200 bg-amber-50 text-amber-700';
      case 'error':
        return 'border border-red-200 bg-red-50 text-red-700';
      case 'lock':
        return 'border border-orange-200 bg-orange-50 text-orange-900';
      default:
        return 'border border-amber-200 bg-amber-50 text-amber-700';
    }
  };

  return (
    <div className={classnames('flex w-full items-center gap-2 rounded-md p-2', getColorClass(), className || '')}>
      {getIcon()}
      <div className="flex-1 text-left text-xs">{children}</div>
    </div>
  );
}
